import { render, staticRenderFns } from "./EntityText.vue?vue&type=template&id=81642cba&scoped=true&"
import script from "./EntityText.vue?vue&type=script&lang=js&"
export * from "./EntityText.vue?vue&type=script&lang=js&"
import style0 from "./EntityText.vue?vue&type=style&index=0&id=81642cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81642cba",
  null
  
)

export default component.exports